export default function getStockCount(stock) {
  if (stock === undefined || stock.length === 0) return 0
  return stock.reduce((a, b) => a + b.count, 0)
}
